import { render, staticRenderFns } from "./DocsForm.vue?vue&type=template&id=7d4ef5da"
import script from "./DocsForm.vue?vue&type=script&lang=js"
export * from "./DocsForm.vue?vue&type=script&lang=js"
import style0 from "./DocsForm.vue?vue&type=style&index=0&id=7d4ef5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports